export const ANGLE_NAMES_FOR_ANIM = { angle1: "a", angle2: "b", angle3: "c", angle4: "d" };
export const ANGLE_COLORS: number[] = [0xFC99C4, 0x21D4FE, 0xf94f6f, 0x0195b8];
export const CIRCLE_RADIUS = 200;
export const POINT_DEGREES = [Math.PI / 18 * 13, Math.PI / 9 * 2, -Math.PI / 9, -Math.PI / 6 * 5];
export const CENTER_OF_CIRCLE = { x: 600, y: 310 };
export const SLIDERS_COORD = [{ x: 420, y: 800 }, { x: 810, y: 800 }];
export const SLIDERS_COORD_OFFSET_VERTICAL = [{ x: 60, y: 400 }, { x: 60, y: 400 }]
export const RANDOM_BUTTON_COORD = { x: 195, y: 800 }
export const INFO_SLIDER_COORD = { x: 1180, y: 200 };
export const BOUNDS_OF_COORD = { x: 1500, y: 800 };
export const CALC_LINES_COORD = [{ x: 750, y: 620 }, { x: 750, y: 670 }]

export const MINI_ANGLE_COORDS = [
  [
    { x: 40, y: 400 },
    { x: 40, y: 350 },
    { x: 100, y: 400 },
    { x: 100, y: 350 },
  ],
  [
    { x: 200, y: 400 },
    { x: 200, y: 350 },
    { x: 200, y: 400 },
    { x: 200, y: 350 }
  ]
]

export const INFO_SLIDER_ASSETS = [
  "/circle-theorem-2/info-slider/1.jpeg",
  "/circle-theorem-2/info-slider/2.jpeg",
  "/circle-theorem-2/info-slider/3.jpeg",
  "/circle-theorem-2/info-slider/4.jpeg",
  "/circle-theorem-2/info-slider/5.jpeg",
  "/circle-theorem-2/info-slider/6.jpeg",
]
